<div
  matRipple
  class="navigation-menu__item"
  [ngClass]="{ 'cm-nav-overview': isOverview }"
  [routerLink]="navigationItem.routerLink"
  routerLinkActive="active-route"
  (mouseover)="isHover = true"
  (mouseleave)="isHover = false"
  (click)="clickHandler()"
  [attr.data-cy]="navigationItem.dataCy"
>
  <div
    class="navigation-menu__item__content"
    [ngClass]="{ ' navigation-menu__item__content--profile':  isProfile
}"
  >
    <mat-icon> {{ navigationItem.iconClass }} </mat-icon>
    <span>{{ navigationItem.name | translate | titlecase }}</span>
  </div>
  <div class="navigation-menu__item__icon-container">
    <mat-icon
      *ngIf="showFavorite"
      class="navigation-menu__item__icon navigation-menu__item__icon--favorite"
      (click)="onFavoriteToggle($event)"
      (mousedown)="onFavoriteToggle($event)"
      [attr.data-cy]="navigationItem.dataCy + (navigationItem.isMarkedAsFavorite ? '-stared-icon' : '-not-stared-icon')"
    >
      {{ navigationItem.isMarkedAsFavorite ? 'star' : 'star_outlined' }}
    </mat-icon>
  </div>
</div>

<div *ngIf="navigationItem.items" class="cm-nav-item__children">
  <cm-navigation-item *ngFor="let item of navigationItem.items" [navigationItem]="item"></cm-navigation-item>
</div>
